import { Typography } from './Typography';
import { DataVisual } from './DataVisual';
import styles from './ServiceCard.module.css';
export function ServiceCard({
  title,
  description,
  kind,
}: {
  title: string;
  description: string;
  kind: 'report' | 'inventory' | 'assets';
}) {
  return (
    <article className={styles.card}>
      <DataVisual kind={kind} />
      <div className={styles.content}>
        <Typography as="h3" variant="subheading">
          {title}
        </Typography>
        <Typography tone="muted">{description}</Typography>
      </div>
    </article>
  );
}
